export default {
    list: [
        {
            "_id": "62b18fc7e27ca6782bfc97a6", 
            "name": "Headline", 
            "en": "Headline", 
            "zh": "头条", 
            "pt": "Título", 
            "es": "Titular", 
            "ja": "見出し", 
            "ko": "표제", 
            "de": "Überschrift", 
            "fr": "Gros titre", 
            "it": "Titolo", 
            "hi": "शीर्षक", 
            "nl": "kop", 
            "ms": "Tajuk", 
            "th": "หัวข้อข่าว", 
            "tl": "Headline", 
            "tr": "başlık", 
            "sv": "Rubrik", 
            "uk": "Заголовок", 
            "ru": "Заголовок", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97a7", 
            "name": "Entertainment", 
            "en": "Entertainment", 
            "zh": "娱乐", 
            "pt": "Entretenimento", 
            "es": "Entretenimiento", 
            "ja": "エンターテイメント", 
            "ko": "오락", 
            "de": "Entertainment", 
            "fr": "Divertissement", 
            "it": "Divertimento", 
            "hi": "मनोरंजन", 
            "nl": "Amusement", 
            "ms": "Hiburan", 
            "th": "ความบันเทิง", 
            "tl": "Aliwan", 
            "tr": "Eğlence", 
            "sv": "Underhållning", 
            "uk": "Розваги", 
            "ru": "Развлечения", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97a8", 
            "name": "Sports", 
            "en": "Sports", 
            "zh": "体育", 
            "pt": "Esportes", 
            "es": "Deportes", 
            "ja": "スポーツ", 
            "ko": "스포츠", 
            "de": "Sport", 
            "fr": "Des sports", 
            "it": "Gli sport", 
            "hi": "खेल", 
            "nl": "Sport", 
            "ms": "sukan", 
            "th": "กีฬา", 
            "tl": "laro", 
            "tr": "Spor Dalları", 
            "sv": "sporter", 
            "uk": "Спорт", 
            "ru": "Спортивный", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97a9", 
            "name": "Technology", 
            "en": "Technology", 
            "zh": "科技", 
            "pt": "Tecnologia", 
            "es": "Tecnología", 
            "ja": "テクノロジー", 
            "ko": "기술", 
            "de": "Technologie", 
            "fr": "Technologie", 
            "it": "Tecnologia", 
            "hi": "तकनीकी", 
            "nl": "Technologie", 
            "ms": "Teknologi", 
            "th": "เทคโนโลยี", 
            "tl": "Teknolohiya", 
            "tr": "teknoloji", 
            "sv": "Teknologi", 
            "uk": "Технологія", 
            "ru": "Технологии", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97aa", 
            "name": "Business", 
            "en": "Business", 
            "zh": "商业", 
            "pt": "O negócio", 
            "es": "Negocio", 
            "ja": "仕事", 
            "ko": "사업", 
            "de": "Geschäft", 
            "fr": "Entreprise", 
            "it": "Affare", 
            "hi": "व्यवसाय", 
            "nl": "Bedrijf", 
            "ms": "Perniagaan", 
            "th": "ธุรกิจ", 
            "tl": "negosyo", 
            "tr": "İşletme", 
            "sv": "Företag", 
            "uk": "Бізнес", 
            "ru": "Бизнес", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97ab", 
            "name": "Lifestyle", 
            "en": "Lifestyle", 
            "zh": "生活", 
            "pt": "Estilo de vida", 
            "es": "Estilo de vida", 
            "ja": "ライフスタイル", 
            "ko": "생활 양식", 
            "de": "Lebensstil", 
            "fr": "Mode de vie", 
            "it": "Stile di vita", 
            "hi": "जीवन शैली", 
            "nl": "levensstijl", 
            "ms": "Cara hidup", 
            "th": "ไลฟ์สไตล์", 
            "tl": "Pamumuhay", 
            "tr": "Yaşam tarzı", 
            "sv": "Livsstil", 
            "uk": "Спосіб життя", 
            "ru": "образ жизни", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62b18fc7e27ca6782bfc97ac", 
            "name": "World", 
            "en": "World", 
            "zh": "世界", 
            "pt": "Mundo", 
            "es": "Mundo", 
            "ja": "世界", 
            "ko": "세계", 
            "de": "Welt", 
            "fr": "Monde", 
            "it": "Mondo", 
            "hi": "दुनिया", 
            "nl": "Wereld", 
            "ms": "dunia", 
            "th": "โลก", 
            "tl": "mundo", 
            "tr": "Dünya", 
            "sv": "Värld", 
            "uk": "Світ", 
            "ru": "Мир", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcadb7be4554ca875ed03", 
            "name": "Local", 
            "en": "Local", 
            "zh": "本地", 
            "pt": "Local", 
            "es": "Local", 
            "ja": "ローカル", 
            "ko": "현지의", 
            "de": "Lokal", 
            "fr": "Local", 
            "it": "Locale", 
            "hi": "स्थानीय", 
            "nl": "lokaal", 
            "ms": "Tempatan", 
            "th": "ท้องถิ่น", 
            "tl": "Lokal", 
            "tr": "Yerel", 
            "sv": "Lokal", 
            "uk": "Місцеві", 
            "ru": "Местный", 
            "priority": 0, 
            "description": "", 
            "enabled": false
        }, 
        {
            "_id": "62bbcb077be4554ca875ed04", 
            "name": "Politics", 
            "en": "Politics", 
            "zh": "政治", 
            "pt": "Política", 
            "es": "Política", 
            "ja": "政治", 
            "ko": "정치", 
            "de": "Politik", 
            "fr": "Politique", 
            "it": "Politica", 
            "hi": "राजनीति", 
            "nl": "Politiek", 
            "ms": "Politik", 
            "th": "การเมือง", 
            "tl": "Pulitika", 
            "tr": "Siyaset", 
            "sv": "Politik", 
            "uk": "політика", 
            "ru": "Политика", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcb237be4554ca875ed05", 
            "name": "Health", 
            "en": "Health", 
            "zh": "健康", 
            "pt": "Saúde", 
            "es": "Salud", 
            "ja": "健康", 
            "ko": "건강", 
            "de": "Die Gesundheit", 
            "fr": "Santé", 
            "it": "Salute", 
            "hi": "स्वास्थ्य", 
            "nl": "Gezondheid", 
            "ms": "Kesihatan", 
            "th": "สุขภาพ", 
            "tl": "Kalusugan", 
            "tr": "Sağlık", 
            "sv": "Hälsa", 
            "uk": "Здоров'я", 
            "ru": "Здоровье", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcb617be4554ca875ed06", 
            "name": "Fashion", 
            "en": "Fashion", 
            "zh": "时尚", 
            "pt": "Moda", 
            "es": "Moda", 
            "ja": "ファッション", 
            "ko": "패션", 
            "de": "Mode", 
            "fr": "Mode", 
            "it": "Moda", 
            "hi": "फ़ैशन", 
            "nl": "Mode", 
            "ms": "Fesyen", 
            "th": "แฟชั่น", 
            "tl": "Fashion", 
            "tr": "Moda", 
            "sv": "Mode", 
            "uk": "Мода", 
            "ru": "Мода", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcb777be4554ca875ed07", 
            "name": "Beauty", 
            "en": "Beauty", 
            "zh": "丽人", 
            "pt": "Beleza", 
            "es": "Belleza", 
            "ja": "美しさ", 
            "ko": "아름다움", 
            "de": "Schönheit", 
            "fr": "Beauté", 
            "it": "Bellezza", 
            "hi": "सुंदरता", 
            "nl": "Schoonheid", 
            "ms": "Kecantikan", 
            "th": "ความงาม", 
            "tl": "kagandahan", 
            "tr": "Güzellik", 
            "sv": "Skönhet", 
            "uk": "краса", 
            "ru": "Красота", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcb967be4554ca875ed09", 
            "name": "Food", 
            "en": "Food", 
            "zh": "美食", 
            "pt": "Comida", 
            "es": "Alimento", 
            "ja": "食べ物", 
            "ko": "음식", 
            "de": "Essen", 
            "fr": "Aliments", 
            "it": "Cibo", 
            "hi": "भोजन", 
            "nl": "Voedsel", 
            "ms": "Makanan", 
            "th": "อาหาร", 
            "tl": "Pagkain", 
            "tr": "Gıda", 
            "sv": "Mat", 
            "uk": "Харчування", 
            "ru": "Еда", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcba47be4554ca875ed0a", 
            "name": "Cars", 
            "en": "Cars", 
            "zh": "汽车", 
            "pt": "Carros", 
            "es": "Coches", 
            "ja": "車", 
            "ko": "자동차", 
            "de": "Autos", 
            "fr": "Voitures", 
            "it": "Macchine", 
            "hi": "कारों", 
            "nl": "auto's", 
            "ms": "kereta", 
            "th": "รถยนต์", 
            "tl": "Mga sasakyan", 
            "tr": "Arabalar", 
            "sv": "Bilar", 
            "uk": "Автомобілі", 
            "ru": "Машины", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcbb47be4554ca875ed0b", 
            "name": "Education", 
            "en": "Education", 
            "zh": "教育", 
            "pt": "Educação", 
            "es": "Educación", 
            "ja": "教育", 
            "ko": "교육", 
            "de": "Ausbildung", 
            "fr": "Éducation", 
            "it": "Formazione scolastica", 
            "hi": "शिक्षा", 
            "nl": "Opleiding", 
            "ms": "Pendidikan", 
            "th": "การศึกษา", 
            "tl": "Edukasyon", 
            "tr": "Eğitim", 
            "sv": "Utbildning", 
            "uk": "Освіта", 
            "ru": "Образование", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcbca7be4554ca875ed0c", 
            "name": "Career", 
            "en": "Career", 
            "zh": "职业", 
            "pt": "Carreira", 
            "es": "Carrera profesional", 
            "ja": "キャリア", 
            "ko": "직업", 
            "de": "Karriere", 
            "fr": "Carrière", 
            "it": "Carriera", 
            "hi": "करियर", 
            "nl": "Carrière", 
            "ms": "Kerjaya", 
            "th": "อาชีพ", 
            "tl": "Karera", 
            "tr": "Kariyer", 
            "sv": "Karriär", 
            "uk": "Кар'єра", 
            "ru": "Карьера", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcbd57be4554ca875ed0d", 
            "name": "Horoscope", 
            "en": "Horoscope", 
            "zh": "星座运势", 
            "pt": "Horóscopo", 
            "es": "Horóscopo", 
            "ja": "星占い", 
            "ko": "점성", 
            "de": "Horoskop", 
            "fr": "Horoscope", 
            "it": "Oroscopo", 
            "hi": "राशिफल", 
            "nl": "Horoscoop", 
            "ms": "Horoskop", 
            "th": "ดูดวง", 
            "tl": "Horoscope", 
            "tr": "Burçlar", 
            "sv": "Horoskop", 
            "uk": "Гороскоп", 
            "ru": "Гороскоп", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }, 
        {
            "_id": "62bbcbde7be4554ca875ed0e", 
            "name": "Pets", 
            "en": "Pets", 
            "zh": "宠物", 
            "pt": "Animais de estimação", 
            "es": "Mascotas", 
            "ja": "ペット", 
            "ko": "애완동물", 
            "de": "Haustiere", 
            "fr": "Animaux domestiques", 
            "it": "Animali domestici", 
            "hi": "पालतू जानवर", 
            "nl": "Huisdieren", 
            "ms": "Haiwan peliharaan", 
            "th": "สัตว์เลี้ยง", 
            "tl": "Mga alagang hayop", 
            "tr": "Evcil Hayvanlar", 
            "sv": "Sällskapsdjur", 
            "uk": "Домашні тварини", 
            "ru": "Домашние питомцы", 
            "priority": 0, 
            "description": "", 
            "enabled": true
        }
    ]
}


// WEBPACK FOOTER //
// ./src/config/categorys.js